import {
  exception
} from '../../util/decorators'
import BaseApi from './BaseApi'

const domain = '//users-api.sanmanuela.net/api'

export default class UserApi extends BaseApi {
  postRequest(response, url) {
    if (url.indexOf('/member/ping') > 0 || url.indexOf('/tools/subscribeStatus') > 0) {
      return response
    }
    if (response.code == 0) {
      return response.data
    }
    throw new Error('token error')
  }

  @exception('获取用户信息失败')
  getCurrent(token) {
    return this.httpGet(domain + '/member/account', {
      token
    })
  }

  heartBeat(token) {
    return this.httpGet(domain + '/member/ping', {
      token
    })
  }

  getFavList(token) {
    return this.httpGet(domain + '/favorite/index', {
      token
    })
  }

  async getFav(token, mid, tid) {
    try {
      return await this.httpGet(domain + '/favorite/detail', {
        token,
        mid,
        tid
      })
    } catch (e) {
      return null
    }
  }

  addFav(token, mid, tid) {
    return this.httpGet(domain + '/favorite/add', {
      token,
      mid,
      tid
    })
  }

  delFav(token, id) {
    return this.httpGet(domain + '/favorite/delete', {
      token,
      id
    })
  }

  getHistory(token, mid) {
    return this.httpGet(domain + '/history/index', {
      token,
      mid
    })
  }

  delHistory(token, id) {
    return this.httpGet(domain + '/history/delete', {
      token,
      id
    })
  }

  getNodeList(token) {
    return this.httpGet(domain + '/notepad/index', {
      token
    })
  }

  getNode(token, mid, tid, urlid) {
    return this.httpGet(domain + '/notepad/detail', {
      token,
      mid,
      tid,
      urlid
    })
  }

  addNode(token, mid, tid, urlid, title, subtitle, content) {
    return this.httpPost(domain + '/notepad/add', {
      token,
      mid,
      tid,
      urlid,
      title,
      subtitle,
      content
    })
  }

  updateNode(token, id, title, subtitle, content) {
    return this.httpPost(domain + '/notepad/edit', {
      token,
      id,
      title,
      subtitle,
      content
    })
  }

  delNode(token, id) {
    return this.httpGet(domain + '/notepad/delete', {
      token,
      id
    })
  }

  getSubscribe(token, type, unionid) {
    return this.httpGet(domain + '/tools/subscribeStatus', {
      token,
      type,
      unionid
    })
  }

  getSetting() {
    return this.httpGet(domain + '/setting')
  }

  getPhoneCode(mobile) {
    return this.httpGet(domain + '/tools/sendSmsCode', {
      mobile
    })
  }

  bindPhone(token, mobile, vcode, itc) {
    return this.httpGet(domain + '/member/bindMobile', {
      token,
      mobile,
      vcode,
      itc
    })
  }

  @exception('登录失败')
  loginByPhone(appid, mobile, vcode, itc) {
    return this.httpGet(domain + '/auth/login_mobile', {
      appid,
      mobile,
      vcode,
      itc
    })
  }
}



// WEBPACK FOOTER //
// ./src/service/api/UserApi.js